import { fromJS } from 'immutable';
import {
  SET_LOGGED_IN_USER_DET,
  SET_VIEW_USER_DET,
  SET_USER_PROFILES,
  SET_SELECTED_PROFILE,
  SET_DEFAULT_PROFILE,
  SET_PROFILES_LOADING,
} from './action';

export const initialState = fromJS({
  user: undefined,
  viewUser: undefined,
  userProfiles: [],
  selectedProfile: null,
  defaultProfileId: null,
  profilesLoading: false,
});

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_LOGGED_IN_USER_DET:
      let nextUser = action.userDet;
      const currUser = state.get('user');
      if (currUser && nextUser) {
        nextUser = {
          ...nextUser,
          userType: currUser.userType,
          roles: currUser.roles,
          // Only the user profile resolves the applicant contact. Account
          // updates (profile save, seed advisor upsert) return the account
          // without it, so keep the one already resolved for that account.
          ...(!('applicant_contact' in nextUser) &&
            currUser.uuid === nextUser.uuid && {
              applicant_contact: currUser.applicant_contact,
            }),
        };
      }
      return state.set('user', nextUser);
    case SET_VIEW_USER_DET:
      return state.set('viewUser', action.userDet);
    case SET_USER_PROFILES:
      return state.set('userProfiles', fromJS(action.profiles || []));
    case SET_SELECTED_PROFILE:
      return state.set(
        'selectedProfile',
        action.profile ? fromJS(action.profile) : null
      );
    case SET_DEFAULT_PROFILE:
      return state.set('defaultProfileId', action.profileId);
    case SET_PROFILES_LOADING:
      return state.set('profilesLoading', action.loading);
    default:
      return state;
  }
};
